import moment from "moment";

function BulkAccountVerificationList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

BulkAccountVerificationList.prototype = Object.assign(BulkAccountVerificationList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.bulkAccountVerificationFileProcessDto &&
            tableData.bulkAccountVerificationFileProcessDto.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            requestId,
            merchantId,
            validCount,
            invalidCount,
            status,
            remark,
            createdDate,
            updatedDate
        } = row;

        const endTime = (updatedDate) ? moment(updatedDate).format("YYYY-MM-DD hh:mm:ss"):  null;
        const startTime = (createdDate) ? moment(createdDate).format("YYYY-MM-DD hh:mm:ss"): null;
        // console.log("start end", startTime, endTime);
        return {
            startTime,
            endTime,
            requestId,
            merchantId,
            validCount,
            invalidCount,
            status,
            remark,
        };
    },
});

export default BulkAccountVerificationList;
